import React from 'react';
import { Dialog, IconButton, DialogTitle, DialogContent, DialogActions} from '@material-ui/core';
import { Button } from 'devextreme-react/button';
import { Close } from '@material-ui/icons';

function AdminDialog(props) {
    const {operation, title, open, onClose, handleOnClick, dialogSize } = props;

    const dialogStyles = {
        width: operation !== 'delete' ? (dialogSize?.width || '550px') : '550px',
        height: operation !== 'delete' ? (dialogSize?.height || '180px') : '180px',
        minWidth: "max-content"
    };

    const buttonStyles = {
        padding: '6px 16px',
        fontSize: '13px', 
        margin:'auto',
        marginTop: '5px',
        borderRadius: '0',
        color: 'white',
        backgroundColor: '#3B5158'
    };

    const buttonSaveStyles = {
        padding: '6px 16px',
        fontSize: '13px', 
        marginRight: '16px',
        marginTop: '5px',
        float:'right',
        borderRadius: '0',
        color: 'white',
        backgroundColor: '#3B5158'
    };

    const closeButton = {
        position: 'absolute',
        right: '6px',
        top: '0px'
    };

    return (
        <Dialog maxWidth={"xl"} open = {open} onClose = {onClose}>
            <div style = {dialogStyles}>
                <DialogTitle disableTypography className="titleStyles" style={{color: 'white', minHeight: "20px", backgroundColor: '#3B5158', marginBottom: '15px', paddingBlock: '12px'}}>
                    {title}
                    {operation !== 'delete' && <IconButton onClick = {onClose} style = {closeButton}> <Close style={{color: "white"}}/> </IconButton>}
                </DialogTitle>
            
                <DialogContent>
                    {props.children}
                </DialogContent>
                <DialogActions>
                    {operation === 'delete' ? 
                        <>
                            <Button onClick={onClose} style={buttonStyles}>Cancelar</Button>
                            <Button onClick={handleOnClick} style={buttonStyles}>Confirmar</Button>                       
                        </>
                    : 
                        <Button onClick={handleOnClick} style={buttonSaveStyles}>Salvar</Button>
                    }
                </DialogActions>
            </div>
        </Dialog>
    );
}

export default AdminDialog;
